import type { CustomCellRendererProps } from "ag-grid-react";
import { defineColumn, transferRowDataInternal } from "presentation/view/components/TableWrapper/BasicTableConstants";
import { EbisInterfaceMonitoringMaintenanceConstant } from "../EbisInterfaceMonitoringMaintenanceConstant";

const SCREEN_CONSTANT = EbisInterfaceMonitoringMaintenanceConstant;
let dateFieldList: string[] = [];
let dateTimeFieldList: string[] = [];
export const INITIAL_EBIS_INTERFACE_MONITORING_COL_DEF_SLARLN: any[] = [
    {
        headerName: SCREEN_CONSTANT.Detail.INTERFACE_LINE_ID,
        field: "interfaceLineId",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.INTERFACE_LINE_CONTEXT,
        field: "interfaceLineContext",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.INTERFACE_LINE_ATTRIBUTE1,
        field: "interfaceLineAttribute1",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.INTERFACE_LINE_ATTRIBUTE2,
        field: "interfaceLineAttribute2",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.INTERFACE_LINE_ATTRIBUTE3,
        field: "interfaceLineAttribute3",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.INTERFACE_LINE_ATTRIBUTE4,
        field: "interfaceLineAttribute4",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.INTERFACE_LINE_ATTRIBUTE5,
        field: "interfaceLineAttribute5",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.INTERFACE_LINE_ATTRIBUTE6,
        field: "interfaceLineAttribute6",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.INTERFACE_LINE_ATTRIBUTE7,
        field: "interfaceLineAttribute7",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.INTERFACE_LINE_ATTRIBUTE8,
        field: "interfaceLineAttribute8",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.BATCH_SOURCE_NAME,
        field: "batchSourceName",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.SET_OF_BOOKS_ID,
        field: "setOfBooksId",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.LINE_TYPE,
        field: "lineType",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.DESCRIPTION,
        field: "description",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.CURRENCY_CODE,
        field: "currencyCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.AMOUNT,
        field: "amount",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.CUST_TRX_TYPE_NAME,
        field: "custTrxTypeName",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.TERM_NAME,
        field: "termName",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ORIG_SYSTEM_BILL_CUSTOMER_REF,
        field: "origSystemBillCustomerRef",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 230,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ORIG_SYSTEM_BILL_ADDRESS_REF,
        field: "origSystemBillAddressRef",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 230,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ORIG_SYSTEM_BILL_CONTAC_REF,
        field: "origSystemBillContactRef",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 230,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ORIG_SYSTEM_SHIP_CUSTOMER_REF,
        field: "origSystemShipCustomerRef",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 230,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ORIG_SYSTEM_SHIP_ADDRESS_REF,
        field: "origSystemShipAddressRef",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 230,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ORIG_SYSTEM_SHIP_CONTAC_REF,
        field: "origSystemShipContactRef",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 230,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ORIG_SYSTEM_SOLD_CUSTOMER_REF,
        field: "origSystemSoldCustomerRef",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 230,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.LINK_TO_LINE_CONTEXT,
        field: "linkToLineContext",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.LINK_TO_LINE_ATTRIBUTE1,
        field: "linkToLineAttribute1",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.LINK_TO_LINE_ATTRIBUTE2,
        field: "linkToLineAttribute2",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.LINK_TO_LINE_ATTRIBUTE3,
        field: "linkToLineAttribute3",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.LINK_TO_LINE_ATTRIBUTE4,
        field: "linkToLineAttribute4",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.LINK_TO_LINE_ATTRIBUTE5,
        field: "linkToLineAttribute5",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.LINK_TO_LINE_ATTRIBUTE6,
        field: "linkToLineAttribute6",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.LINK_TO_LINE_ATTRIBUTE7,
        field: "linkToLineAttribute7",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.RECEIPT_METHOD_NAME,
        field: "receiptMethodName",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.CONVERSION_TYPE,
        field: "conversionType",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.CONVERSION_DATE,
        field: "conversionDate",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.CONVERSION_RATE,
        field: "conversionRate",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.TRX_DATE,
        field: "trxDate",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 100,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.GL_DATE,
        field: "glDate",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 100,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.DOCUMENT_NUMBER,
        field: "documentNumber",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.TRX_NUMBER,
        field: "trxNumber",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.LINE_NUMBER,
        field: "lineNumber",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.QUANTITY_ORDERED,
        field: "quantityOrdered",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.UNIT_SELLING_PRICE,
        field: "unitSellingPrice",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.REFERENCE_LINE_CONTEX,
        field: "referenceLineContext",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 200,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.REFERENCE_LINE_ATTRIBUTE1,
        field: "referenceLineAttribute1",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 230,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.REFERENCE_LINE_ATTRIBUTE2,
        field: "referenceLineAttribute2",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 230,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.REFERENCE_LINE_ATTRIBUTE3,
        field: "referenceLineAttribute3",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 230,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.REFERENCE_LINE_ATTRIBUTE4,
        field: "referenceLineAttribute4",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 230,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.REFERENCE_LINE_ATTRIBUTE5,
        field: "referenceLineAttribute5",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 230,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.REFERENCE_LINE_ATTRIBUTE6,
        field: "referenceLineAttribute6",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 230,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.REFERENCE_LINE_ATTRIBUTE7,
        field: "referenceLineAttribute7",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 230,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.REFERENCE_LINE_ATTRIBUTE8,
        field: "referenceLineAttribute8",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 230,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.CREDIT_METHOD_FOR_ACCT_RULE,
        field: "creditMethodForAcctRule",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 230,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.CREDIT_METHOD_FOR_INSTALLMENTS,
        field: "creditMethodForInstallments",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 250,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.REASON_CODE,
        field: "reasonCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 100,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.TAX_RATE,
        field: "taxRate",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 100,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.TAX_CODE,
        field: "taxCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 100,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.TAX_PERCEDENCE,
        field: "taxPrecedence",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.SHIP_DATE_ACTUAL,
        field: "shipDateActual",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.FOB_POINT,
        field: "fobPoint",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 120,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.SHIP_VIA,
        field: "shipVia",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 120,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.WAYBILL_NUMBER,
        field: "waybillNumber",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.INVOICING_RULE_NAME,
        field: "invoicingRuleName",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ACCOUNT_RULE_NAME,
        field: "accountRuleName",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ACCOUNT_RULE_DURATION,
        field: "accountingRuleDuration",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 280,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.RULE_START_DATE,
        field: "ruleStartDate",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.PRIMARY_SALESREP_NUMBER,
        field: "primarySalesrepNumber",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 280,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.SALES_ORDER,
        field: "salesOrder",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 120,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.SALES_ORDER_LINE,
        field: "salesOrderLine",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.SALES_ORDER_DATE,
        field: "salesOrderDate",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.SALES_ORDER_SOURCE,
        field: "salesOrderSource",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.SALES_ORDER_REVISION,
        field: "salesOrderRevision",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.AGREEMENT_NAME,
        field: "agreementName",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.MEMO_LINE_NAME,
        field: "memoLineName",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.CUSTOMER_BANK_ACCOUNT_NAME,
        field: "customerBankAccountName",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 280,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.UOM_NAME,
        field: "uomName",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 100,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.TAX_EXEMPT_REASON_CODE,
        field: "taxExemptReasonCode",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.TAX_EXEMPT_NUMBER,
        field: "taxExemptNumber",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.DOC_CREATED_BY,
        field: "docCreatedBy",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.DOC_CREATED_DATE,
        field: "docCreationDate",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.DOC_LAST_UPDATED_BY,
        field: "docLastUpdatedBy",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.DOC_LAST_UPDATED_DATE,
        field: "docLastUpdateDate",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ORG_ID,
        field: "orgId",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 100,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ATTRIBUTE1,
        field: "attribute1",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 100,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ATTRIBUTE2,
        field: "attribute2",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 100,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ATTRIBUTE3,
        field: "attribute3",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 100,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ATTRIBUTE4,
        field: "attribute4",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 100,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ATTRIBUTE5,
        field: "attribute5",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 100,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ATTRIBUTE6,
        field: "attribute6",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 100,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ATTRIBUTE7,
        field: "attribute7",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 100,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ATTRIBUTE8,
        field: "attribute8",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 100,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ATTRIBUTE9,
        field: "attribute9",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 100,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ATTRIBUTE10,
        field: "attribute10",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 100,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.ATTRIBUTE_CATEGORY,
        field: "attributeCategory",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 180,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.HEADER_ATTRIBUTE1,
        field: "headerAttribute1",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.HEADER_ATTRIBUTE2,
        field: "headerAttribute2",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.HEADER_ATTRIBUTE3,
        field: "headerAttribute3",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.HEADER_ATTRIBUTE4,
        field: "headerAttribute4",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.HEADER_ATTRIBUTE5,
        field: "headerAttribute5",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.HEADER_ATTRIBUTE6,
        field: "headerAttribute6",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.HEADER_ATTRIBUTE7,
        field: "headerAttribute7",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.HEADER_ATTRIBUTE8,
        field: "headerAttribute8",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.HEADER_ATTRIBUTE9,
        field: "headerAttribute9",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.HEADER_ATTRIBUTE10,
        field: "headerAttribute10",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.HEADER_ATTRIBUTE11,
        field: "headerAttribute11",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.HEADER_ATTRIBUTE12,
        field: "headerAttribute12",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },

    {
        headerName: SCREEN_CONSTANT.Detail.HEADER_ATTRIBUTE13,
        field: "headerAttribute13",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.HEADER_ATTRIBUTE14,
        field: "headerAttribute14",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.HEADER_ATTRIBUTE15,
        field: "headerAttribute15",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 150,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.HEADER_ATTRIBUTE_CATEGORY,
        field: "headerAttributeCategory",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 280,
    },

    {
        headerName: SCREEN_CONSTANT.Detail.COMMENTS,
        field: "comments",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 100,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.GLOBAL_ATTRIBUTE_CATEGORY,
        field: "globalAttributeCategory",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 280,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.GLOBAL_ATTRIBUTE1,
        field: "globalAttrbute1",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.GLOBAL_ATTRIBUTE2,
        field: "globalAttrbute2",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.GLOBAL_ATTRIBUTE3,
        field: "globalAttrbute3",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.GLOBAL_ATTRIBUTE4,
        field: "globalAttrbute4",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.GLOBAL_ATTRIBUTE5,
        field: "globalAttrbute5",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.GLOBAL_ATTRIBUTE6,
        field: "globalAttrbute6",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.GLOBAL_ATTRIBUTE7,
        field: "globalAttrbute7",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.GLOBAL_ATTRIBUTE8,
        field: "globalAttrbute8",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.GLOBAL_ATTRIBUTE9,
        field: "globalAttrbute9",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },
    {
        headerName: SCREEN_CONSTANT.Detail.GLOBAL_ATTRIBUTE10,
        field: "globalAttrbute10",
        enableRowGroup: false,
        enablePivot: true,
        enableValue: false,
        rowGroup: false,
        filter: true,
        width: 130,
    },

].map((col, index) => {
    const cellRenderers: { [key: string]: ((params: CustomCellRendererProps) => {}) } = {};

    return defineColumn(col, index, dateFieldList, dateTimeFieldList, [], cellRenderers);
});

export const transferRowDataForSLARLN = (data: any[]) => {
    const externalFnctions: { [key: string]: ((fieldName: string, row: any) => {}) } = {};

    return transferRowDataInternal(data, dateFieldList, dateTimeFieldList, [], externalFnctions);
}
